import { Route } from "react-router";
import { Fragment } from "react/jsx-runtime";
import { SocialWall } from "./SocialWall";
import { useApplicationParameters } from "../../api/client-api/appParams/useApplicationParameters";

export const useSocialRouter = () => {
    const { applicationParameters } = useApplicationParameters();

    // Check if news feed feature is enabled
    const isNewsFeedEnabled = applicationParameters?.["FS-news-feed"] === "true";

    if (!isNewsFeedEnabled) {
        return <Fragment />;
    }

    return (
        <Fragment>
            <Route path="social">
                <Route index element={<SocialWall />} />
            </Route>
        </Fragment>
    );
};
